export class LancamentoPesquisa {

  public ContaId: number;
  public UnidadeId: number;
  public DataInicial: string;
  public DataFinal: string;
  public TipoDR: string;
  public TipoDeAcaoId: number;

  constructor() {
    this.ContaId = null;
    this.UnidadeId = null;
    this.TipoDeAcaoId = 0;
  }
}

export class MovimentacaoLancamento {
  public Id: number;
  public TipoDR: string;
  public Conta: string;
  public Participante: string;
  public ParticipanteCpfCnpj: string;
  public UsuarioCriacao: string;
  public Unidade: number;
  public Documento: number;
  public Historico: string;
  public HistoricoReceber: string;
  public HistoricoPagar: string;
  public Valor: number;
  public CreditoDebito: string;
  public Data: string;
  public Saldo: number;
  public ReceberId: number;
  public PagarId: number;
  public ProcessoId: number;
  public ProcessoFicha: number;
  public NotaEmitida: boolean;

  constructor() { }
}
